import { useResolve } from "@movicoders/di";
import { IOperatorService, OperatorService } from "@domain/services/IOperatorService";

export const useHandleOperator = () => {
  const { saveOperatorState, persistedState: operatorState, clearOperatorState } = useResolve<IOperatorService>(OperatorService);

  return { saveOperatorState, operatorState, clearOperatorState };
};
